import React, { useState } from "react";
import { TextArea } from "../../../components/forms/TextArea";
import { QuestionWithRelations } from "../../../../../api/src/types";
import { validateTextWithRestriction } from "../utils/questionnaire";
import { useGetCurrentUserQuery } from "../../../api/users";
import { useUpsertAnswerMutation } from "../../../api/answers";
import { QUESTIONNAIRE_INPUT_PLACEHOLDER_TEXT } from "../../../components/theme";
import { ErrorWrapper, InputWrapper } from "./SharedFormStyles";

interface TextAreaInputProps {
  question: QuestionWithRelations;
  documentId: string;
}

const TextAreaInput: React.FC<TextAreaInputProps> = ({
  question,
  documentId,
}) => {
  const [textAreaInput, setTextAreaInput] = useState<string | null>(
    question.answers[0]?.valueTyped ?? null,
  );
  const [textAreaError, setTextAreaError] = useState<string | null>(null);

  const { data: user } = useGetCurrentUserQuery();
  const [
    upsertAnswer,
    {
      /*isLoading: isCreating,*/
      isError: isUpsertError,
      /*isSuccess: isCreateSuccess,*/
      /*isSuccess: isUpdateSuccess,*/
      reset: resetUpdateAnswer,
    },
  ] = useUpsertAnswerMutation();

  const hasAnswer = question.answers.length > 0;

  const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    resetUpdateAnswer();

    const value = e.target.value;
    setTextAreaInput(value);

    // Validate text area input with restrictions
    const error = validateTextWithRestriction(value, question);
    setTextAreaError(error);

    if (!user) return;

    const payload = {
      questionId: question.id,
      userId: user.id,
      documentId,
      rootQuestionId: question.rootQuestionId ?? question.id,
      sectionId: question.parentQuestionnaireSectionId,
      valueTyped: value,
      serializeDebounceMs: 1200,
    };

    if (error) {
      if (hasAnswer) {
        void upsertAnswer({ ...payload, valueTyped: null });
      }
      return;
    }

    // Avoid creating empty answers
    if (!hasAnswer && value.trim().length === 0) return;

    void upsertAnswer(payload);
  };

  const handleBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    const trimmedValue = e.target.value.trim();

    // Update local state for immediate visual feedback; backend will handle trimming on save
    if (trimmedValue !== textAreaInput) {
      setTextAreaInput(trimmedValue);
    }
  };

  //const isLoading = isCreating || isUpdating;
  const hasError = isUpsertError;
  /*const isSuccess =
    (isCreateSuccess || isUpdateSuccess) &&
    !hasError &&
    !isLoading &&
    !textAreaError &&
    textAreaInput !== "";
  */
  return (
    <>
      <InputWrapper>
        <TextArea
          placeholder={QUESTIONNAIRE_INPUT_PLACEHOLDER_TEXT}
          value={textAreaInput ?? ""}
          onChange={(e) => {
            handleTextAreaChange(e);
          }}
          onBlur={handleBlur}
          rows={4}
          required={question.isRequired}
          errorMessage={textAreaError}
        />
        {/* Commenting out the loader and success icon for now as per the request of the design team */}
        {/*
        {isLoading && (
          <IconContainer>
            <Loader spinnerOnly={true} size={isMobile ? 16 : 34} />
          </IconContainer>
        )}
        {isSuccess && (
          <IconContainer>
            <GreenTick size={isMobile ? IconSize.S : IconSize.XL} />
          </IconContainer>
        )}
        */}
      </InputWrapper>
      {hasError && (
        <ErrorWrapper>
          Error saving answer, please refresh the page and try again
        </ErrorWrapper>
      )}
    </>
  );
};

export default TextAreaInput;
